export const MAX_RECEIPT_FILE_SIZE_BYTES = 10 * 1024 * 1024;

export const RECEIPT_MIME_TYPES = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp",
  "application/pdf",
] as const;

export function validateReceiptFile(file: File): string | null {
  if (!RECEIPT_MIME_TYPES.includes(file.type as (typeof RECEIPT_MIME_TYPES)[number])) {
    return "Choose a JPG, PNG, GIF, WEBP, or PDF receipt.";
  }

  if (file.size > MAX_RECEIPT_FILE_SIZE_BYTES) {
    return "The receipt must be 10 MB or smaller.";
  }

  return null;
}
